import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import MaterialTable, { MTableAction } from "material-table";
import {IconButton, FormControl, InputLabel, Select, OutlinedInput, MenuItem, Button, TextField} from '@material-ui/core';
import AddButton from './AddButton';


const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export  function BankAPI_groups(props) {

    const classes = useStyles();

    const { show } = props;

    const tableRef = React.createRef();
    const addActionRef = React.useRef();

    const columns = [
        {title:"id", field:"gr_id"},
        {title:"Номер", field:"gr_number"}, 
        {title:"Назва", field:"gr_name"},
        {title:"Навчальний рік", field: "periodStartYear"}
/*        {
          title: "Додати нового користувача",
          field: "add_action",
          editable: false,
          render: (rowData) =>
            rowData && (
              <IconButton
                color="secondary"
                onClick={() => addActionRef.current.click()}
              >
                <AddIcon />
              </IconButton>
            )
        }
*/
    ];

    
    const [id_kg, setIdKg] = useState('');

    const [listKgs, setListKgs] = useState([]);
    
    const [display, setShow] = useState(false);


    const getListOfKg = async ()=> {

      if(!id_kg || id_kg.length !== 24 ) return;

      const url = 'https://osa.kyivcity.gov.ua/bank_api/kg_groups/' + id_kg;

      const result = await fetch(url);

      if(!result.ok) {
        console.log("error by fetch", url);
        alert("Error by sending req");
        return;
      }
  
      const info = await result.json();

      const d_ = info && info.data && info.data.map(kg=>kg);


      setListKgs(d_);

    }

    if(!show) return null;

    return (
      <div style={{ maxWidth: "100%" }}>
        <TextField inputProps={{ size: 24 }} label="Ід садочка" value={id_kg} onChange={(e)=>setIdKg(e.target.value)} />
        <div><Button onClick={getListOfKg}>Отримати інформацію</Button></div>
        <MaterialTable
          tableRef={tableRef}
          columns={columns}
          data={listKgs}
          title="АПІ для банків. Групи в садочку"
          components={{
            Action: props=><AddButton {...props} />
          }}

          icons={
            { Add: ()=> <IconButton onClick={()=>{}} />}
          }

          actions={[
          ]}
          options={{
            filtering: true,
            pageSize: 10,
            pageSizeOptions: [10,20,50]
          }}
        />
      </div>
    );

}